import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import Header from '../Header/Header';
import './NewsStory.css';

import { Markdown } from 'react-showdown';


// import * as actions from '../../actions/index';

// import ReactMarkdown from 'react-markdown';
// import MarkdownToStoryImage from '../../helpers/remark-markdowntostoryimage';
            // <ReactMarkdown 
            //   className="news-content" 
            //   plugins={this.props.title === 'News with inline image(s)' ? [MarkdownToStoryImage] : []} 
            //   source={this.props.content} 
            // />



function formatAuthorDate(date) {
  date = new Date(date);
  return [date.getDate(), date.getMonth() + 1, date.getFullYear()].join('/');
}

const getHeroImage = function(images) {
  const defaultImage = '';
  return ((images || []).filter(im => im.hero)[0] || (images || [])[0]) || defaultImage;
}

class NewsStory extends React.Component {
  propTypes: {
    title: propTypes.string,
    content: propTypes.string,
    author: propTypes.string,
    currentNews: propTypes.string,
    date: propTypes.datetime,
  }
  render() {
    const heroImage = getHeroImage(this.props.images);
    return (
      <section className={"news-story" + (this.props.currentNews === this.props._id ? ' selected' : '') + (heroImage ? ' has-hero-image' : '')}>
        <section className="author-panel">
          <div className="news-date">{formatAuthorDate(this.props.date)}</div>
          <div className="news-author">by {this.props.author}</div>
        </section>
        <section className="content-panel">
          <Header
            title={this.props.title}
          />
          {heroImage && 
            <img className={'NewsStory__heroImage'} src={heroImage.data} alt={heroImage.filename} />
          }
          <section className="content">
            <Markdown 
              className="news-content" 
              markup={this.props.content} 
              extensions={[ 'showdownstoryimage' ]}
            />
          </section>
        </section>
      </section>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
  };
}

export default connect(null, mapDispatchToProps)(NewsStory);



// WEBPACK FOOTER //
// ./src/components/NewsStory/NewsStory.js